import OneEdition from './components/one_edition'
import TwoEdition from './components/two_edition'
import ThreeEdition from './components/three_edition'
import FourEdition from './components/four_edition'
import FiveEdition from './components/five_edition'
import app from './transportationEnterprises_app'
import Axios from "axios"


export default {
  data() {
    return {
      dataTime:null,
      isMerchants:false,
      isOrders:false,
      merchantList:[],
      orderList:[],
      animateUp: false,
      timer: null,
      animateOrder: false,
      timerOrder: null,
      smallViewPort: false,
      swiperOptions: {
        speed: 800,
        direction: "vertical",
        mousewheel: true,
        parallax: true,
        pagination: {
          el: ".full-swiper-pagination",
          bulletActiveClass: "full-swiper-pagination-custom-bullet-active",
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className} full-swiper-pagination-custom-bullet">${
              this.swiperList[index].title
              }</span>`;
          }
        },
        navigation: {
          nextEl: ".pagenation-bar-next",
          prevEl: ".pagenation-bar-prev"
        }
      },
      swiperList: [
        {
          title: "01"
        },
        {
          title: "02"
        },
        {
          title: "03"
        },
        {
          title: "04"
        },
        {
          title: "05"
        }
      ],
      tip:'保存中...',
      tzData:{
        name:'',//姓名
        telephone:'',//
        email:'',//
        cityCode:'510000',//
        city:'四川省',//
        businessType:'加盟',//业务类型 1-大客户 2-投资 3-加盟
        addCity:'成都',//加盟城市
        addArea:'600㎡以下',//加盟面积
        addCharging:'60kw以下',//充电桩
        addCooperationMode:'场站委托运营',//合作模式
        addEstimatedCost: '50000.00',//加盟预计费用
        path:'/chargingFranchise',
      }
    }
  },
  components: {
    OneEdition,
    TwoEdition,
    ThreeEdition,
    FourEdition,
    FiveEdition,
    app,
  },
  computed:{
  },
  watch: {},
  mounted() {
    this.timer = setInterval(this.scrollAnimate, 1500);
    this.timerOrder = setInterval(this.scrollOrderAnimate, 2000);
    this.getData()
    this.dataTime =setInterval(this.getData, 60000);
  },
  methods: {
    async getData(){
      await this.getMerchants();
      await this.getOrders();
      setTimeout(() => {
        this.isMerchants = true
        this.isOrders = true
      }, 500)
    },
    getMerchants(){
      this.merchantList=[]
      Axios.get('https://sgn.aostarit.com.cn/awl-member-service/enterpriseEntry/enterpriseShow').then(res=>{
        res.data.data.forEach(vv1=>{
          vv1.createdOn = vv1.createdOn.split(" ")[0]
          this.merchantList.push(vv1)
        })
      }).catch(error=>{
        this.isMerchants = false
      })
    },
    getOrders(){
      Axios.get('https://sgn.aostarit.com.cn/awl-logistics-service/orderStatistics/orderShow').then(res=>{
        this.orderList = res.data.data
      }).catch(error=>{
        this.isOrders = false
      })
    },
    handleResize() {
      const windowWidth = document.documentElement.offsetWidth;
      if (windowWidth <= 767) {
        this.smallViewPort = true;
      } else {
        this.smallViewPort = false;
      }
    },
    gotoPage(){
      this.$router.push({
        name: 'mobileApply',
        params: this.tzData
      });
    },
    scrollAnimate() {
      if(this.merchantList.length<7)return
      this.animateUp = true
      setTimeout(() => {
        this.merchantList.push(this.merchantList[0])
        this.merchantList.shift()
        this.animateUp = false
      }, 500)
    },
    scrollOrderAnimate() {
      if(this.orderList.length<4)return
      this.animateOrder = true
      setTimeout(() => {
        this.orderList.push(this.orderList[0])
        this.orderList.shift()
        this.animateOrder = false
      }, 1000)
    },
    clearTime(index){
      if(index){
        clearInterval(this.timerOrder)
      }else{
        clearInterval(this.timer)
      }
    },
    addTime(index){
      if(index){
        this.timerOrder = setInterval(this.scrollOrderAnimate, 2000);
      }else{
        this.timer = setInterval(this.scrollAnimate, 1500);
      }
    },
  },
  destroyed() {
    clearInterval(this.timer)
    clearInterval(this.timerOrder)
    clearInterval(this.dataMerchantsTime)
    clearInterval(this.dataOrdersTime)
  }
}
